import { ReadOnlyStepProps } from "../useStepEditor";
import { Stack, Title } from "@introist/react-foundation/v2";
import { useAutomationStep } from "../../../automations/hooks/useAutomationStep";
import { Block } from "../../../../components/atoms";
import { StepEditorAccordion } from "../../../workflows/routes/WorkflowEditor/StepEditorAccordion";
import { DataSourceIcon } from "modules/datasources/components/DataSourceIcon";

export const HibobUpdateEmailStepViewer = ({ stepId }: ReadOnlyStepProps) => {
  const { step } = useAutomationStep({ id: stepId });

  if (!step) return <div />;

  const stepData = step.stepData as any;
  const resolvedData = step.resolvedData as any;

  const email = resolvedData?.resolvedEmail || stepData?.email;

  return (
    <>
      <Block blended compact>
        <StepEditorAccordion title="Target">
          <StepEditorAccordion.Row label="Data source">
            <Stack>
              <DataSourceIcon dataSource="hibob" size="small" />
              <Title variant="bold">HiBob</Title>
            </Stack>
          </StepEditorAccordion.Row>
        </StepEditorAccordion>
      </Block>
      <Block blended compact>
        <StepEditorAccordion title="Email" defaultOpen>
          {email && <Title>{email}</Title>}
        </StepEditorAccordion>
      </Block>
    </>
  );
};
